export default {
  id: '',
  description: '',
  amount: '',
  is_wholesale: '',
};
